/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Industries {
  constructor() {}

  public industries = [
    {
      label: `Banking`,
      value: 'Banking',
    },
    {
      label: `Insurance`,
      value: 'Insurance',
    },
    {
      label: `Management`,
      value: 'Investment Management',
    },
    {
      label: `Fintech`,
      value: 'Fintech',
    },
    {
      label: `Services`,
      value: 'Other Financial Services',
    },
    {
      label: `Retail`,
      value: 'Retail',
    },
    {
      label: `eCommerce`,
      value: 'eCommerce',
    },
    {
      label: `Gaming`,
      value: 'Online Gaming',
    },
    {
      label: `Media`,
      value: 'Social Media',
    },
    {
      label: `Services`,
      value: 'Online Business Services',
    },
    {
      label: `Services`,
      value: 'Other Online Services',
    },
    {
      label: `Platform`,
      value: 'IOT Platform',
    },
    {
      label: `Software`,
      value: 'Software',
    },
    {
      label: `Computers`,
      value: 'Computers',
    },
    {
      label: `Electronics`,
      value: 'Other Electronics',
    },
    {
      label: `Consulting`,
      value: 'IT Consulting',
    },
    {
      label: `Government`,
      value: 'Government',
    },
    {
      label: `Healthcare`,
      value: 'Healthcare',
    },
    {
      label: `Hospitality`,
      value: 'Hospitality',
    },
    {
      label: `Logistics`,
      value: 'Logistics',
    },
    {
      label: `Transportation`,
      value: 'Transportation',
    },
    {
      label: `Manufacturing`,
      value: 'Manufacturing',
    },
    {
      label: `Media`,
      value: 'Media',
    },
    {
      label: `Pharmaceuticals`,
      value: 'Pharmaceuticals',
    },
    {
      label: `Telecommunications`,
      value: 'Telecommunications',
    },
    {
      label: `Utilities`,
      value: 'Utilities',
    },
    {
      label: `Education`,
      value: 'Education',
    },
    {
      label: `Other`,
      value: 'Other',
    },
  ];
}
